export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.7-1436.16",
  commitId: "c5144020afb418731f7ead5b4a97d5a4f5da99b7",
  commitTime: "2026-08-07T14:36:16.000Z",
});
